// StripeProvider is kept as a pass-through — Stripe Elements are mounted
// only in Checkout.tsx with the correct clientSecret.
export function StripeProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
